import { useEffect, useRef } from "react";

// Passive AdSense display banner — non-rewarded.
// Renders an <ins.adsbygoogle> slot that Google fills with whatever
// auction-priced display creative is most relevant. Used on
// Library + below-the-fold Dashboard sections to surface incremental
// CPC/CPM revenue without disrupting the credit-earning UX (which is
// now exclusively powered by CPX Research surveys).
//
// The AdSense main script (`adsbygoogle.js`) is loaded once globally
// from /public/index.html, so we only need to push() this slot.
export default function PassiveAdBanner({ slot, format = "auto", responsive = true, label = "Sponsored", className = "" }) {
  const client = process.env.REACT_APP_ADSENSE_CLIENT;
  const insRef = useRef(null);

  useEffect(() => {
    if (!client || !slot) return;
    if (!client.startsWith("ca-pub-")) return;
    // AdSense throws "already have ads in this page" if the same <ins>
    // gets push'd twice. We only push if data-adsbygoogle-status is unset.
    try {
      const node = insRef.current;
      if (!node) return;
      if (node.getAttribute("data-adsbygoogle-status")) return;
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* fail-soft — passive ads must never crash the page */
    }
  }, [client, slot]);

  if (!client || !slot) return null;
  return (
    <div className={`w-full ${className}`} data-testid="passive-ad-banner">
      <div className="text-[10px] uppercase tracking-[0.2em] text-white/30 mb-1.5 px-1">{label}</div>
      <ins
        ref={insRef}
        className="adsbygoogle block"
        style={{ display: "block", minHeight: 90 }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
    </div>
  );
}
